import type { FC } from 'react';

import * as styles from './ParentalControlHeader.module.scss';

interface HeaderProps {
  titleText: string;
  subtitleText: string;
}

const ParentalControlsHeader: FC<HeaderProps> = ({
  titleText,
  subtitleText,
}) => {
  return (
    <>
      <div className={styles.header}>{titleText}</div>
      <div className={styles.prompt}>{subtitleText}</div>
    </>
  );
};

export { ParentalControlsHeader };
